import React from 'react';
import { FieldRenderProps } from 'react-final-form';
import CheckboxField, { CheckboxFieldProps } from './CheckboxField';

const CheckboxFieldAdapter: React.FC<CheckboxFieldProps & FieldRenderProps<boolean>> = ({
  input,
  meta,
  onChange,
  ...rest
}) => {
  const errorMessage = meta && meta.touched && meta.error ? meta.error : '';
  return (
    <CheckboxField
      {...input}
      {...rest}
      errorMessage={errorMessage}
      onChange={(e) => {
        const target = e.target as HTMLInputElement;
        input.onChange(target.checked);
        if (onChange) {
          onChange(e);
        }
      }}
    />
  );
};

export default CheckboxFieldAdapter;
